import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { gameStore, GameState } from '../game/store';
const SPEAKER_META: Record<string, {
  label: string;
  color: string;
  border: string;
  bg: string;
  accent: string;
}> = {
  narrator: {
    label: '',
    color: 'text-gray-200',
    border: 'border-gray-500',
    bg: 'bg-gray-950/90',
    accent: 'bg-gray-500'
  },
  carl: {
    label: 'CARL',
    color: 'text-blue-200',
    border: 'border-blue-500',
    bg: 'bg-blue-950/80',
    accent: 'bg-blue-500'
  },
  system: {
    label: '/// THE SYSTEM ///',
    color: 'text-red-300',
    border: 'border-red-500',
    bg: 'bg-red-950/80',
    accent: 'bg-red-500'
  },
  mordecai: {
    label: 'MORDECAI',
    color: 'text-emerald-200',
    border: 'border-emerald-500',
    bg: 'bg-emerald-950/80',
    accent: 'bg-emerald-500'
  },
  donut: {
    label: 'PRINCESS DONUT',
    color: 'text-pink-200',
    border: 'border-pink-500',
    bg: 'bg-pink-950/80',
    accent: 'bg-pink-500'
  },
  gnome: {
    label: 'MRS. WARTBOTTOM',
    color: 'text-amber-200',
    border: 'border-amber-500',
    bg: 'bg-amber-950/80',
    accent: 'bg-amber-500'
  },
  goblin_king: {
    label: 'THE GOBLIN KING',
    color: 'text-purple-200',
    border: 'border-purple-500',
    bg: 'bg-purple-950/80',
    accent: 'bg-purple-500'
  }
};
export function DialogueBox() {
  const [state, setState] = useState<GameState>(gameStore.getState());
  useEffect(() => gameStore.subscribe(setState), []);
  // Auto-advance dialogue based on duration
  useEffect(() => {
    const current = state.dialogueQueue[0];
    if (!current) return;
    const dur = current.duration || 4000;
    const t = setTimeout(() => gameStore.advanceDialogue(), dur);
    return () => clearTimeout(t);
  }, [state.dialogueQueue[0]?.text]);
  const current = state.dialogueQueue[0];
  const meta = current ? SPEAKER_META[current.speaker] || SPEAKER_META.narrator : null;
  return <div className="absolute bottom-24 left-1/2 -translate-x-1/2 w-full max-w-3xl px-4 pointer-events-none z-30" data-id="element-23">
      <AnimatePresence mode="wait" data-id="element-24">
        {current && meta && <motion.div key={current.text} initial={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -10,
        scale: 0.98
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className={`${meta.bg} ${meta.border} border-2 backdrop-blur-md p-4 md:p-5 pointer-events-auto cursor-pointer relative`} onClick={() => gameStore.advanceDialogue()} data-id="element-25">
            {/* Side accent bar */}
            <div className={`absolute left-0 top-0 bottom-0 w-1 ${meta.accent}`} data-id="element-26" />

            {meta.label && <div className={`${meta.color} text-xs uppercase tracking-[0.3em] mb-2 opacity-80 font-bold`} data-id="element-27">
                {meta.label}
              </div>}
            <div className={`${meta.color} text-base md:text-lg leading-relaxed ${current.speaker === 'system' ? 'font-bold uppercase tracking-wider' : ''} ${current.speaker === 'narrator' ? 'italic' : ''}`} data-id="element-28">
              {current.text}
            </div>

            <div className="absolute bottom-2 right-3 text-xs text-gray-500 tracking-widest uppercase" data-id="element-29">
              Click to skip ▸
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}